import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDreamteam = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 10,
		cy: 10,
		r: 9.5,
		fill: "#12326E",
		stroke: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10 3L11.5716 7.83688H16.6574L12.5429 10.8262L14.1145 15.6631L10 12.6738L5.8855 15.6631L7.4571 10.8262L3.3426 7.83688H8.4284L10 3Z",
		fill: "white"
	})]
});
export default SvgDreamteam;
